import { PurchaseMediumPartialStoreState, PURCHASE_MEDIUM_STATE_KEY } from './medium.reducer';

export const selectedMedium = (state: PurchaseMediumPartialStoreState) => state[PURCHASE_MEDIUM_STATE_KEY].selectedMedium;

export const availableMediumGroups = (state: PurchaseMediumPartialStoreState) => state[PURCHASE_MEDIUM_STATE_KEY].availableMediumGroups;
export const selectedMediumGroup = (state: PurchaseMediumPartialStoreState) => state[PURCHASE_MEDIUM_STATE_KEY].selectedMediumGroup;
export const cardTypeMask = (state: PurchaseMediumPartialStoreState) => state[PURCHASE_MEDIUM_STATE_KEY].cardTypeMask;
